module.exports = __webpack_public_path__ + "static/media/perpustakaan.a006c735.jpeg";